import { Content } from '../../types';

export const angkorWatContent: Content = {
  title: 'אנגקור וואט - המקדש האייקוני של קמבודיה',
  imageUrl: 'https://tinyurl.com/angkor-wat-preview',
  introduction: `אנגקור וואט הוא המקדש ההינדו-בודהיסטי הגדול והמרשים ביותר במתחם אנגקור שבקמבודיה ונחשב לאחד מפלאי הארכיטקטורה של העולם העתיק. המקדש ממוקם ליד העיר סיאם ריפ ונבנה במאה ה-12 על ידי המלך סוריאוורמן השני כמקדש הינדואי המוקדש לאל וישנו. מאוחר יותר, במהלך המאה ה-14 וה-15, הפך אנגקור וואט למרכז דתי בודהיסטי.`,
  sections: [
    {
      title: 'ארכיטקטורה ועיצוב',
      content: `המקדש בנוי בסגנון קלאסי של האימפריה הקמרית, עם השפעות הינדואיות ברורות. הוא מדמה את הר מרו, ההר המקודש במיתולוגיה ההינדואית ומשלב חמישה מגדלים מחודדים המסמלים את פסגות ההר. המרכזי מביניהם, מגיע לגובה של כ-65 מטר.

אנגקור וואט מתפרש על שטח של כ-162 הקטארים, מה שהופך אותו למקדש הדתי הגדול בעולם. המקדש מוקף חפיר מים רחב, מה שמעניק לו מראה מרהיב, במיוחד בשעות הזריחה כאשר השתקפותו נשקפת מהמים.`,
      type: 'text',
    },
    {
      title: 'תבליטים וגילופים',
      content: `הקירות של אנגקור וואט מכוסים תבליטים מפורטים המתארים סצנות מתוך ה"אפוסים ההינדואיים רמאיאנה ומהאבהארטה", לצד תיאורים של קרבות היסטוריים ודמויות מיתולוגיות. אחד התבליטים המפורסמים ביותר הוא "סצנת חביצת ים החלב", המתארת את המיתוס ההינדואי על יצירת הנקטר של חיי הנצח.`,
      type: 'text',
    },
    {
      title: 'מעבר מהינדואיזם לבודהיזם',
      content: `למרות שמקדש אנגקור וואט נבנה במקור כמקדש הינדואי, במהלך השנים הוא עבר תהליך הדרגתי של בודהיזציה. כיום, ניתן למצוא במקום פסלי בודהה לצד האלמנטים ההינדואיים המקוריים.`,
      type: 'text',
    },
    {
      title: 'ביקור במקדש',
      content: `הזמן האידיאלי לבקר במקדש הוא עם הזריחה, אז השמש מאירה את המבנה בגוונים זהובים וכתומים. הכניסה למתחם אפשרית דרך גשר אבן ארוך שמוביל לשער הראשי ומשם ניתן להתרשם מהאולמות, הפרוזדורים והחצרות הפנימיות.`,
      type: 'text',
    },
    {
      title: 'מקדש אנגקור וואט',
      content: '',
      type: 'image',
      imageUrl: 'https://tinyurl.com/angkor-wat-article-1',
    },
    {
      title: 'סמל לאומי',
      content: `אנגקור וואט הוא לא רק אתר תיירותי אלא גם סמל לאומי של קמבודיה ומופיע על דגלה הרשמי של המדינה.`,
      type: 'text',
    },
    {
      title: 'בשורה התחתונה',
      content: `אנגקור וואט הוא דוגמה יוצאת דופן לאדריכלות הקמרית ולמורשת התרבותית של קמבודיה. מדובר באחד המקומות המרשימים והחשובים ביותר בדרום-מזרח אסיה וכדאי להקדיש לו לפחות חצי יום כדי לחקור את כולו.`,
      type: 'text',
    },
  ],
};
